import { useContext, useEffect, useState } from "react"
import getServicesBlob from "../services/getServicesBlob"
import deleteService from "../services/deleteService"
import { AuthContext } from "../contexts/auth"
import toast from "react-hot-toast"
import getServices from "../services/getServices"


const useLocalTarefa = () => {

    const { signOut } = useContext(AuthContext)
    const [openDialog, setOpenDialog] = useState(false)

    const [localTarefaDeletar, setLocalTarefaDeletar] = useState(false)

    const [pesquisa, setPesquisa] = useState('')
    const [localTarefa, setLocalTarefa] = useState('')
    const [qrcodeLocalTarefa, setQrcodeLocalTarefa] = useState('')    
    const [submit, setSubmit] = useState(false)

    //Campos para a paginação
    const [nexPage, setNextPage] = useState(null)
    const [previusPage, setPreviusPage] = useState(null)
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);
    
    //pesquisa a lista de locais
    const _getLocalTarefa = async (pageToFetch = 1)=>{
        if (submit){
            return;
        }
        setSubmit(true)

        let url = `admin/local/?page=${pageToFetch}`;
        if (pesquisa !== '') url += `&pesquisa=${pesquisa}`;

        let result = await getServices(url);

        if (result.type === 'success'){
           setLocalTarefa(result.data.results.map(item=>{return {id:item.id, 
                                                          name: item.nome, 
                                                          nome_posto: item.posto?.nome, 
                                                          ativo:item.ativo,
                                                          editavel:item.editavel,
                                                          CodPosto: item.posto.codigo,
                                                          quantidade_tarefas: item.quantidade_tarefas,
                                                        } }))

           setNextPage(result.data.next)
           setPreviusPage(result.data.previous)
           setTotalCount(result.data.count);
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _buscaQRcode = async (idlocal) => {
        if (submit){
            return;
        }        
        setSubmit(true)        
        let result = await getServicesBlob(`admin/qrcodelocal/?id=${idlocal}`)
        if (result.type === 'success'){
            const url = window.URL.createObjectURL(result.data);       
            setQrcodeLocalTarefa(url)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else if (result.type === 'error'){
            setQrcodeLocalTarefa('')
        }
        setSubmit(false)        
    }    

    const _deleteLocal = async ()=>{
        if (submit){
            return;
        }
        
        setOpenDialog(false)
        setSubmit(true)
        let result = await deleteService(`admin/local/${localTarefaDeletar.id}/`)
        if (result.type === 'success'){
            
            toast.success(result.data.detail)
            _getLocalTarefa()
        }
        else if (result.type === 'error'){
            toast.error(result.data.detail.status)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }     

    useEffect(() => {
        // Se quiser buscar automaticamente ao mudar a página:
        _getLocalTarefa(page + 1);
    }, [page]);

    return {
        pesquisa: {value: pesquisa, set:setPesquisa},
        openDialog: {value: openDialog, set:setOpenDialog},
        deletar: {value: ()=>{console.log('não implementado')}, set: _deleteLocal},
        itemDelete:{value:localTarefaDeletar, set:setLocalTarefaDeletar},  
        localTarefa: {value: localTarefa, set:_getLocalTarefa},
        qrcodeLocalTarefa : {value:qrcodeLocalTarefa, set:_buscaQRcode},
        pagination: {
            total: totalCount,
            page: page,
            setPage: setPage
        },    
        submit: { value: submit, set: (p) => _getLocalTarefa(p !== undefined ? p : page + 1) }, 
    }
}

export default useLocalTarefa